module.exports = __webpack_public_path__ + "static/media/anUnmarkedPlace.34fbf56e.jpg";